export default [
  { name: "西安", value: 12 },
  { name: "广州", value: 32 },
  { name: "南京", value: 25 },
  { name: "合肥", value: 62 },
  { name: "武汉", value: 32 },
  { name: "北京", value: 34 },
  { name: "上海", value: 94 },
  { name: "深圳", value: 14 },
  { name: "成都", value: 82 },
  { name: "沈阳", value: 3 },
];
